import { get } from 'lodash-es';
import { LIMITED_TIME_OFFER_MAKES } from 'client/constants/make-exclusions';
import { isNew } from './is-new';

export function isLimitedTimeOffer(inventory) {
  const invMake = get(inventory, 'vehicleInfo.styleInfo.make', '').toLowerCase();
  return isNew(inventory.type) && LIMITED_TIME_OFFER_MAKES.some(make => make.toLowerCase() === invMake);
}
